import { Box, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { MobileInfoIcon, PanelClose, PanelOpen } from '../../assets/icons/icons'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { PanelControlButtonProps } from './PanelControlButton.config';

const PanelControlButton = (props: PanelControlButtonProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    props.setOpen(!props.open);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    
        <IconButton onClick={handleClick} disableRipple sx={{padding:0}}>
            {matches ?
            <Stack justifyContent={"center"} alignItems={"center"}>
                <MobileInfoIcon/>
                <Typography sx={{color:"black"}} variant='customBodyXsCondensed'>Info</Typography>
            </Stack>
            :
            <>
            { props.open ?
                <Stack justifyContent={"center"} alignItems={"center"}>
                    <PanelClose/>
                    <Typography sx={{color:"black"}} variant='customBodyXsCondensed'>Close</Typography>
                </Stack>
                :
                <Stack justifyContent={"center"} alignItems={"center"}>
                    <PanelOpen/>
                    <Typography sx={{color:"black"}} variant='customBodyXsCondensed'>Info</Typography>
                </Stack>
            }
            </>
            }
            
        </IconButton>
    
  )
}

export default PanelControlButton